import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

import { fetchFhirPrescriptions } from 'store/currentPatient/actions/fhir';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFhirPrescriptions.STARTED]: handleActionStart,
  [fetchFhirPrescriptions.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  [fetchFhirPrescriptions.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.prescriptions,
  [clearCurrentPatient]: () => initialState,
});
